// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";
import 'photoswipe/style.css';

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import lightbox from "./lightbox"


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();



/* Add lightbox to gallery images */
lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );